<template>
  <div>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-navigation-drawer
          v-model="sideNav3"
          fixed
          temporary
          color="#202020"
          class="hidden-lg-and-up"
        >
          <v-layout wrap justify-center>
            <v-flex
              xs12
              v-for="(item, i) in categories"
              :key="i"
              text-center
              pa-2
              pl-4
              text-uppercase
              align-self-center
            >
              <v-layout wrap justify-center>
                <router-link :to="item.route" style="text-decoration: none">
                  <v-flex xs12>
                    <span
                      style="
                        font-family: ibmplexsansregular;
                        font-size: 15px;
                        color: #ffffff;
                        letter-spacing: 3px;
                        cursor: pointer;
                      "
                      >{{ item.name }}</span
                    >
                  </v-flex>
                </router-link>
                <v-flex xs12 pt-2>
                  <div style="border-bottom: 1px solid #ffffff25"></div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-navigation-drawer>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-app-bar
          app
          dark
          color="#00000"
          dense
          flat
          height="50px"
          class="hidden-md-and-up"
        >
          <v-app-bar-nav-icon @click.native="sideNav3 = !sideNav3">
            <v-icon color="#fffff">mdi-menu</v-icon>
          </v-app-bar-nav-icon>
          <v-layout wrap justify-space-around>
            <v-flex align-self-center xs1>
              <!-- <v-img
                height="100% "
                :width="$vuetify.breakpoint.name == 'xs' ? '30px' : '31px'"
                contain
                src="../../assets/images/Group 208.svg"
              ></v-img> -->
            </v-flex>
            <!-- </v-app-bar-nav-icon> -->
            <!-- <v-toolbar-title> -->
            <!-- <v-layout wrap justify-center> -->
            <v-flex align-self-center xs10 text-center pt-0 pt-sm-0>
              <span style="color: white; font-family: MontserratSemiBold"
                >DMAAC</span
              >
            </v-flex>
            <!-- <v-flex align-self-center text-center xs1 sm1 md4 lg4 xl4>
              <v-menu bottom offset-y transition="scale-transition">
                <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-account-circle-outline</v-icon>
                </template>
                <v-list>
                  <v-list-item @click="logout()">
                    <v-list-item-title>Logout </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-flex> -->
          </v-layout>
          <!-- </v-layout> -->
          <!-- </v-toolbar-title> -->
        </v-app-bar>
      </v-flex>
    </v-layout>
    <v-app-bar
      color="#00000"
      dark
      elevation="0"
      height="60px"
      class="hidden-sm-and-down"
    >
      <v-layout wrap justify-center pt-2 pb-1 pb-md-4 pb-lg-3>
        <v-flex xs12 sm12 md3 lg3 xl3 text-left pl-0>
          <v-layout wrap justify-center hidden-md-and-down>
            <v-flex xs2 align-self-start pt-3>
              <!-- <v-img
                width="15px"
                src="../../assets/images/Group 208.svg"
              ></v-img> -->
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl5>
              <span style="font-family: MontserratSemiBold; font-size: 14px"
                >DMAAC</span
              >
            </v-flex>
          </v-layout>
          <v-layout wrap justify-start hidden-lg-and-up>
            <v-flex xs2 align-self-start pt-3>
              <!-- <v-img
                width="15px"
                src="../../assets/images/Group 208.svg"
              ></v-img> -->
            </v-flex>
            <v-flex md7 lg6 xl6>
              <span style="font-family: MontserratSemiBold; font-size: 14px"
                >DMAAC</span
              >
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm12 md7 lg7 xl7 pt-1>
          <v-layout wrap justify-end>
            <v-flex xs10>
              <v-layout wrap justify-space-between>
                <v-flex v-for="(item, i) in categories" :key="i">
                  <router-link :to="item.route" style="text-decoration: none">
                    <span
                      style="
                        font-family: ibmplexsansregular;
                        font-size: 14px;
                        cursor: pointer;
                        color: #FFFFFF;
                      "
                    >
                      {{ item.name }}
                    </span>
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-spacer></v-spacer>
        <!-- <v-layout justify-start wrap>
          <v-flex xs12 sm12 md4 lg3 xl4>
            <v-menu bottom offset-y transition="scale-transition">
              <template v-slot:activator="{ on }">
                <v-avatar style="cursor: pointer" size="40" v-on="on">
                  <v-img :src="mediaURL + imga" />
                </v-avatar>
                <v-icon v-on="on">mdi-account-circle-outline</v-icon>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-title>Logout </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout> -->
      </v-layout>
    </v-app-bar>
  </div>
</template>
<script>
// import axios from "axios";
// import store from "../../store";
import ServerError from "./500";
export default {
  components: {
    ServerError,
  },
  data() {
    return {
      hover: false,
      appLoading: false,
      ServerError: false,
      sideNav: false,
      sideNav2: false,
      sideNav3: false,
      user: [],
      categories: [
        {
          name: "Services",
          route: "/",
          type: "link",
        },
        {
          name: "About Us",
          route: "/",
          type: "link",
        },
        {
          name: "Why DMAAC",
          route: "/",
          type: "link",
        },
        {
          name: "Customer Stories",
          route: "/",
          type: "link",
        },
        {
          name: "Blog",
          route: "/",
          type: "link",
        },
        {
          name: "Contact Us",
          route: "/",
          type: "link",
        },
      ],
      stylCategories: [],
      userName: null,
      profilePic: null,
      cartItems: 0,
      disabledNav: true,
      searchKey: null,
    };
  },
  //   computed: {
  //     appLogin() {
  //       return this.$store.state.isLoggedIn;
  //     },
  //     imga() {
  //       return store.state.profilePic;
  //     },
  //   },
  watch: {
    sideNav() {
      this.$emit("stepper", {
        sideNav: this.sideNav,
      });
    },
  },
  mounted() {
    // this.getData();
  },
  methods: {
    // logout() {
    //   store.commit("logoutUser");
    //   localStorage.removeItem("token");
    //   localStorage.removeItem("isLoggedIn");
    //   this.$router.push("/");
    // },
    // getData() {
    //   this.appLoading = true;
    //   axios({
    //     method: "GET",
    //     url: "/user/profile",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //   })
    //     .then((response) => {
    //       this.appLoading = false;
    //       if (response.data.status) {
    //         this.user = response.data.data;
    //         // this.userStatus = this.user.status;
    //         console.log(this.user);
    //       }
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },
  },
};
</script>

<style>
input::-webkit-input-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: poppinsregular !important;
}
input::-moz-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: poppinsregular !important;
}
.searchBox .v-input__control {
  min-height: 10px !important;
}
.searchBox .v-input__control .v-input__slot {
  padding: 0px !important;
}
.v-application--is-ltr
  .v-toolbar__content
  > .v-btn.v-btn--icon:first-child
  + .v-toolbar__title,
.v-application--is-ltr
  .v-toolbar__extension
  > .v-btn.v-btn--icon:first-child
  + .v-toolbar__title {
  padding-left: 0px !important;
}
</style>

